import { useMutation } from '@tanstack/react-query';

import type { CreateRiskAssessmentTemplatePayload } from 'api/RiskAssessmentTemplatesApi';
import { RiskAssessmentTemplatesApi } from 'api/RiskAssessmentTemplatesApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { RISK_ASSESSMENT_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useCreateRiskAssessmentTemplate() {
  const riskAssessmentTemplatesApi = new RiskAssessmentTemplatesApi();
  const { userBankId } = useUser();
  const { invalidateRiskAssessmentTemplates } = useFiRiskAssessmentCache();

  const { mutateAsync: createRiskAssessmentTemplate, isPending: isCreatingRiskAssessmentTemplate } =
    useMutation({
      mutationKey: [RISK_ASSESSMENT_TEMPLATES_KEY, 'create'],
      mutationFn: (data: CreateRiskAssessmentTemplatePayload) =>
        riskAssessmentTemplatesApi.createRiskAssessmentTemplate(userBankId, data),
      onSuccess: () => {
        invalidateRiskAssessmentTemplates();
      },
      meta: {
        snackbarErrorMessage: 'There was an issue creating the template. Please contact support.'
      }
    });

  return { createRiskAssessmentTemplate, isCreatingRiskAssessmentTemplate };
}
